/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import cssobj from 'cssobj';

/**
 * @ngdoc service
 * @name cssobj
 * @description
 *
 *     Wrapper on top of https://github.com/cssobj/cssobj.
 */
angular.module('avi/deps').factory('cssobj', () => cssobj);
